/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { TemplateAttributeType } from './';
import {
    TemplateAttributeTypeFromJSON,
    TemplateAttributeTypeFromJSONTyped,
    TemplateAttributeTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface TemplateAttribute
 */
export interface TemplateAttribute {
    /**
     * 
     * @type {TemplateAttributeType}
     * @memberof TemplateAttribute
     */
    type: TemplateAttributeType;
    /**
     * 
     * @type {string}
     * @memberof TemplateAttribute
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateAttribute
     */
    label?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TemplateAttribute
     */
    required: boolean;
}

/**
 * Check if a given object implements the TemplateAttribute interface.
 */
export function instanceOfTemplateAttribute(value: object): value is TemplateAttribute {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('required' in value) || value['required'] === undefined) return false;
    return true;
}

export function TemplateAttributeFromJSON(json: any): TemplateAttribute {
    return TemplateAttributeFromJSONTyped(json, false);
}

export function TemplateAttributeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TemplateAttribute {
    if (json == null) {
        return json;
    }
    return {
        
        'type': TemplateAttributeTypeFromJSON(json['type']),
        'name': json['name'],
        'label': json['label'] == null ? undefined : json['label'],
        'required': json['required'],
    };
}

export function TemplateAttributeToJSON(value?: TemplateAttribute | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'type': TemplateAttributeTypeToJSON(value['type']),
        'name': value['name'],
        'label': value['label'],
        'required': value['required'],
    };
}

